import React, { FC } from 'react'
import { Col, Row, Space, Table, Typography } from 'antd'
import { useShopping } from '../hooks'
import { formatCurrency, getPricePeriod } from '../utils'
import { Header } from './Header'
import { SummaryButton } from './SummaryButton'

const { Text, Title } = Typography

const columns = [
  {
    title: 'Product Name',
    dataIndex: 'name',
    key: 'name',
    render: (_, { product }) => (
      <Text>
        {product.meta?.isSeatProduct 
          ? `${product.product.name} - ${product.price.name}` 
          : `${product.product.name}`}
      </Text>
    )
  },
  {
    title: 'Unit Price',
    dataIndex: 'unitPrice',
    key: 'unitPrice',
    render: (_, { product }) => (
      <Text>
        {formatCurrency(product.price.unit_price.amount, 
          product.price.unit_price.currency_code)}
      </Text>
    )
  },
  {    
    title: 'Quantity',
    dataIndex: 'quantity',
    key: 'quantity',
    render: (_, { key }) => (
      <SummaryButton productId={key} />
    )
  },
  {
    title: 'Price',
    dataIndex: 'price',
    key: 'price',
    render: (_, { product, quantity }) => (
      <Text>
        {formatCurrency(product.price.unit_price.amount * quantity, 
          product.price.unit_price.currency_code)}
      </Text>
    )
  }
]

export const Summary: FC = () => {
  const { chart, totalAmount } = useShopping()

  return (
    totalAmount > 0 
    ? <Space direction='vertical' style={{ width: '100%' }}>
      <Header
        key={'seat'}
        title={'Your order summary'}
      />
      <Row 
        justify={'center'} 
        align={'middle'}
        gutter={[16, 16]}
      >
        <Col span={18}>
          <Row justify={'center'} align={'middle'} gutter={[8, 8]}>
            <Table
              pagination={false}
              size='small'
              style={{
                width: '100%'
              }}
              columns={columns}
              dataSource={Object.values(chart).filter(({ quantity }) => quantity > 0)}
              summary={() => {
                return (
                <Table.Summary fixed>
                  <Table.Summary.Row>
                    <Table.Summary.Cell index={0}>
                      <Space size={'small'}>
                        <Text strong>
                          Total
                        </Text>
                        <Text type="secondary" style={{ fontSize: '12px', fontWeight: 'normal' }}>
                          / {getPricePeriod(Object.values(chart)[0]?.product.price) === 'yearly' ? 'year' : 'month'}
                        </Text>
                      </Space>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={1}>
                      {' '}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={2}>
                      {' '}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={3}>
                      <Title level={5} type='success'>
                        {`${formatCurrency(totalAmount, Object.values(chart)[0]?.product.price.unit_price.currency_code || 'USD')} + VAT/Tax`}
                      </Title>
                    </Table.Summary.Cell>
                  </Table.Summary.Row>
                </Table.Summary>
                )
              }}
            />
          </Row>
        </Col>
      </Row>
    </Space> 
    : null
  )
}
